<template>
  <!-- Message InputAdd commentMore actions -->
  <b-form class="chat-app-form" @submit.prevent="addMessage">
    <div class="chat-input-container">
      <!-- Emoji picker -->
      <b-button variant="link" class="icon-button" @click="toggleEmojiPicker">
        <feather-icon icon="SmileIcon" size="20" />
      </b-button>
      <!-- Emoji Picker (abajo del botón) -->
      <div v-if="showEmojiPicker" class="emoji-picker-container">
        <Picker @select="addEmoji" />
      </div>

      <!-- Textarea -->
      <b-form-textarea
        v-model="localMessage"
        rows="1"
        max-rows="4"
        class="chat-textarea"
        :placeholder="$t('pages.chat.typeMessage')"
        @keydown.enter.prevent="addMessage"
      />

      <!-- Image Upload -->
      <input
        ref="fileInput"
        type="file"
        class="d-none"
        accept="image/*"
        @change="handleFileUpload"
      />
      <!-- Preview Image -->
      <div v-if="imagePreview" class="image-preview">
        <img :src="imagePreview" class="preview-thumb" />
        <button class="remove-preview" @click="removeImage">×</button>
      </div>
      <b-button variant="link" class="icon-button" @click="$refs.fileInput.click()">
        <feather-icon icon="ImageIcon" size="20" />
      </b-button>

      <!-- Send button -->
      <b-button variant="link" class="icon-button" type="submit">
        <feather-icon icon="SendIcon" size="20" />
      </b-button>
    </div>
  </b-form>
</template>

<script>
import _ from "lodash";
import { BForm, BInputGroup, BFormInput, BButton, BFormTextarea } from "bootstrap-vue";
import { Picker } from "emoji-mart-vue";
import "emoji-mart-vue/css/emoji-mart.css";

export default {
  name: "InputChat",
  components: {
    BForm,
    BInputGroup,
    BFormInput,
    BButton,
    BFormTextarea,
    Picker,
  },
  props: {
    chatInputMessage: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    // ... your existing data
    showEmojiPicker: false,
    imageFile: null,
    imagePreview: null,
    localMessage: "",
  }),
  watch: {
    chatInputMessage(newVal) {
      immediate: true, (this.localMessage = newVal);
    },
  },
  methods: {
    toggleEmojiPicker() {
      this.showEmojiPicker = !this.showEmojiPicker;
    },

    addEmoji(emoji) {
      this.localMessage += emoji.native;
      this.showEmojiPicker = false;
    },

    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        if (file.type.startsWith("image/")) {
          this.imageFile = file;
          this.createImagePreview(file);
        } else {
          // Show error for invalid file type
          this.$bvToast.toast(this.$t("pages.chat.invalidFileMessage"), {
            title: this.$t("pages.chat.invalidFileTitle"),
            variant: "danger",
          });
        }
      }
    },

    createImagePreview(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.imagePreview = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    removeImage() {
      this.imageFile = null;
      this.imagePreview = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },

    async addMessage() {
      this.$emit("send-message", this.localMessage, this.imageFile);
      // Reiniciar mensaje local y emitir cambio
      this.localMessage = "";
      this.$emit("update:chatInputMessage", "");
      this.removeImage();
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-app-form {
  .chat-input-container {
    display: flex;
    width: 100%;
  }

  .chat-textarea {
    flex-grow: 1;
    resize: none;
    border: none;
    outline: none;
    box-shadow: none;
    background-color: transparent;
    padding: 0.5rem;
    font-size: 1rem;
    line-height: 1.5;
  }

  .icon-button {
    padding: 0.25rem;
    margin-left: 0.25rem;
    color: #54656f;

    &:hover {
      background-color: #f5f5f5;
    }
  }

  .image-preview {
    margin-top: 0.5rem;
    display: flex;
    align-items: center;
    position: relative;

    .preview-thumb {
      height: 60px;
      width: 60px;
      object-fit: cover;
      border-radius: 8px;
      margin-right: 0.5rem;
    }

    .remove-preview {
      position: absolute;
      top: -5px;
      left: 55px;
      background: #dc3545;
      color: white;
      border: none;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      line-height: 1;
      font-size: 12px;
      cursor: pointer;
    }
  }
  .emoji-picker-container {
    position: absolute;
    bottom: 60px;
    left: 10px;
    z-index: 999;
  }
}
</style>
